import Vue from "vue";

Vue.filter("money", function (value) {
  if (value == 0) return "0";
  if (!value) return "";
  return Intl.NumberFormat().format(value);
});
